











import { Session } from '../../utils/Session';
import { Vue, Component } from 'vue-property-decorator';
import CoDashBoard from './CoDashBoard.vue';
import DaDashBoard from './DaDashBoard.vue';
@Component({
  components: { CoDashBoard, DaDashBoard },
})
export default class StudentDashBoardPage extends Vue {
  get isCo() {
    return Session.isCircleOBuilding();
  }
}
